import EntityChallenges from './EntityChallenges';

export default EntityChallenges;
